import styles from "../../styles/addReceipt.module.css";
import { formatCurrency } from "../../../../../shared/utils/formatCurrency";

const ESTILO_SELECT = {
  width: "100%",
  padding: "8px 12px",
  background: "var(--bg-input)",
  border: "1px solid var(--border-card)",
  borderRadius: 7,
  color: "var(--text-primary)",
  fontSize: "0.88rem",
};

const ESTILO_LABEL = {
  display: "block",
  color: "var(--text-secondary)",
  fontSize: "0.78rem",
  fontWeight: 600,
  marginBottom: 4,
};

/**
 * Panel de destino del sobrante, igual en Generar Recibo y en Aplicar Recibo.
 *
 * Cruza las dos columnas del grid (span-full): como hijo directo de
 * .receipt-container, sin eso cae en una celda y los selectores salen cortados.
 */
export function SaldoFavorPanel({
  destinoFavor,
  setDestinoFavor,
  rubroFavor,
  setRubroFavor,
  rubros,
  destinosFavor,
  disabled = false,
}) {
  return (
    <div
      className={styles["span-full"]}
      style={{
        // Mismo fondo que .receipt-footer y sin margen: el panel y la fila de
        // botones leen como un solo bloque. Con su tinte morado y su borde
        // quedaba como una tarjeta aparte, separada del footer por un hueco.
        margin: 0,
        padding: "16px",
        background: "var(--bg-card-alt)",
        display: "flex",
        gap: 14,
        flexWrap: "wrap",
        alignItems: "flex-end",
      }}
    >
      <div style={{ flex: "1 1 260px" }}>
        <label style={ESTILO_LABEL}>Destino del saldo a favor</label>
        <select
          value={destinoFavor}
          onChange={(e) => setDestinoFavor(e.target.value)}
          disabled={disabled}
          style={ESTILO_SELECT}
        >
          <option value="nueva">Nueva cuenta de saldo a favor (SF-)</option>
          {destinosFavor.map((f) => (
            <option key={f.id} value={String(f.factura.id_factura)}>
              {f.factura.numero_factura} · ya a favor{" "}
              {f.moneda === "USD" ? "$" : "₡"}
              {formatCurrency(Math.abs(Number(f.saldo)))}
            </option>
          ))}
        </select>
      </div>

      {destinoFavor === "nueva" && (
        <div style={{ flex: "1 1 260px" }}>
          <label style={ESTILO_LABEL}>
            Rubro <span style={{ color: "#f87171" }}>*</span>
          </label>
          <select
            value={rubroFavor}
            onChange={(e) => setRubroFavor(e.target.value)}
            disabled={disabled}
            style={ESTILO_SELECT}
          >
            <option value="">- Seleccionar -</option>
            {rubros.map((r) => (
              <option key={r.id} value={String(r.id)}>
                {r.codigo} - {r.nombre}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
